export default "__VITE_ASSET__BTkOzcdo__"